import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from 'js/redux/store'
import App from './App'
import '../scss/app'

if (module.hot) {
  module.hot.accept()
}

const root = createRoot(document.getElementById('app'))
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
)
